import { validateEqual } from './equal.validator';
import { ValidateCheckbox } from './checkbox.validator';
import { ValidateSchool } from './school.validator';
const ɵ0 = validateEqual, ɵ1 = ValidateCheckbox, ɵ2 = ValidateSchool;
export class ValidatorsModule {
}
export { ɵ0, ɵ1, ɵ2 };
